
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hashtag/[[...query]]",
      function () {
        return require("private-next-pages/hashtag/[[...query]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hashtag/[[...query]]"])
      });
    }
  